import m from "big.js";
import { getCommonQuery as r, graphRequest as s } from "./util/graphql.mjs";
import { provider as k } from "./store/provider.mjs";
async function v(o = {}) {
  const i = {
    ...r(),
    where: {
      ...o.where
    }
  };
  return await s(
    (t) => `
    {
      options(${t}) {
        id
        address
        bullet
        sniper
        strikePrice
        startTimestamp
        exerciseTimestamp
        optionType
        tradeCount
      }
    }`,
    i
  ).then((t) => t?.options ?? []);
}
async function g(o = {}) {
  const i = {
    ...r(o),
    where: {
      ...o.where
    }
  };
  return await s(
    (t) => `
    {
      pools(${t}) {
        id
        token
        option
        startBlock
        endBlock
        rewardPerBlock
        stakedAmount
        totalAmount
        exerciseAmount
        isActive
      }
    }`,
    i
  ).then((t) => t?.pools ?? []);
}
async function S(o = {}) {
  const { isActive: i = !0, isStarted: e = !0 } = o;
  let t;
  e && (t = await k.getBlockNumber());
  const a = {
    ...r(o),
    where: {
      ...o.where,
      isActive: i,
      startBlock_lte: t
    }
  };
  return await s(
    (c) => `{
  pools(${c}) {
    id
    token
    option
    startBlock
    endBlock
    rewardPerBlock
    stakedAmount
    totalAmount
    exerciseAmount
    isActive
  }
}`,
    a
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((c) => c?.pools ?? []);
}
async function T() {
  return await s(
    (e) => `{
  hodlpools(${e}) {
    id
    token
    option
    startBlock
    endBlock
    rewardPerBlock
    stakedAmount
  }
}`,
    {
      first: 2
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((e) => e?.hodlpools ?? []);
}
async function y(o) {
  return await s(
    (t) => `{
  hodlpoolAccounts(${t}) {
    id
    poolId
    account
    staked
  }
}`,
    {
      where: {
        account: o
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((t) => t?.hodlpoolAccounts ?? []);
}
async function $(o = {}) {
  const i = {
    ...r(),
    where: {
      ...o.where
    }
  };
  return await s(
    (e) => `{
      hodlpoolAccounts(${e}) {
        id
        poolId
        account
        staked
      }
    }`,
    i
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((e) => e?.hodlpoolAccounts ?? []);
}
async function x(o = {}) {
  let i;
  o.type === "buy" ? i = 1 : o.type === "sell" && (i = 0);
  const e = {
    ...r(o),
    orderBy: "exerciseTimestamp",
    orderDirection: "desc",
    where: {
      optionType: i,
      exerciseTimestamp_gte: o.startTime,
      exerciseTimestamp_lt: o.endTime
    }
  };
  let t = await s(
    (n) => `
    {
      options(${n}) {
        id,
        address,
        bullet,
        sniper,
        strikePrice,
        startTimestamp,
        exerciseTimestamp,
        optionType,
        tradeCount
      }
    }
    `,
    e
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((n) => n?.options ?? []);
  const a = t.map((n) => n.id), l = {
    ...r(),
    where: {
      id_in: a,
      isActive: o.isActive
    }
  }, c = await s(
    (n) => `
    {
      pools(${n}) {
        id,
        token,
        option,
        startBlock,
        endBlock,
        rewardPerBlock,
        stakedAmount,
        totalAmount,
        exerciseAmount,
        isActive
      }
    }
    `,
    l
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((n) => n?.pools ?? []), p = {};
  if (c.forEach((n) => {
    p[n.id] = n;
  }), t = t.map((n) => {
    const d = p[n.id];
    return d !== void 0 ? { ...n, pool: d } : n;
  }), o.isStarted !== void 0 && (t = t.filter(
    (n) => o.isStarted === !0 ? Number(n.startTimestamp) * 1e3 <= (/* @__PURE__ */ new Date()).getTime() : Number(n.startTimestamp) * 1e3 > (/* @__PURE__ */ new Date()).getTime()
  )), o.address === void 0) return t;
  const h = a.map(
    (n) => `${n}_${o.address?.toLowerCase()}`
  ), w = {
    ...r(),
    where: {
      id_in: h
    }
  }, f = await s(
    (n) => `
    {
      optionAccounts(${n}) {
        id,
        optionId,
        account,
        sniper,
        bullet,
        initSniper,
        totalSniper,
        totalBullet,
        stakedSniper,
      }
    }
    `,
    w
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((n) => n?.optionAccounts ?? []), u = {};
  return f.forEach((n) => {
    u[n.optionId] = n;
  }), t = t.map((n) => {
    const d = u[n.id];
    return d !== void 0 ? {
      ...n,
      isEntered: !0,
      initSniper: d.initSniper,
      totalSniper: d.totalSniper,
      stakedSniper: d.stakedSniper,
      totalBullet: d.totalBullet
    } : {
      ...n,
      initSniper: "0",
      totalSniper: "0",
      totalBullet: "0",
      stakedSniper: "0"
    };
  }), o.address !== void 0 && (t = t.filter((n) => n.isEntered)), o.state === "staked" ? t.filter(
    // @ts-expect-error, it is temporarily being ignored
    (n) => n.stakedSniper !== void 0 && m(n.stakedSniper).gt(0)
  ) : t;
}
async function I(o) {
  const i = {
    ...r(),
    where: {
      ...o?.where
    }
  };
  return await s(
    (e) => `{
  optionAccounts(${e}) {
    id
    optionId
    account
    sniper
    bullet
    initSniper
    totalSniper
    totalBullet
    stakedSniper
  }
}`,
    i
  ).then((e) => e.optionAccounts ?? []);
}
async function L(o) {
  const i = {
    ...r(),
    where: {
      account: o
    }
  };
  return await s(
    (t) => `{
  optionAccounts(${t}) {
    id
    optionId
    account
    sniper
    bullet
    initSniper
    totalSniper
    totalBullet
    stakedSniper
  }
}`,
    i
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((t) => t?.optionAccounts ?? []);
}
async function P(o) {
  const e = await s(
    (t) => `
    {
      optionAccounts(${t}) {
        id,
        optionId,
        account,
        bullet,
        sniper,
        initSniper,
        totalSniper,
        totalBullet,
        stakedSniper,
      }
    }
    `,
    {
      first: 1,
      where: { id: o }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((t) => t?.optionAccounts ?? []);
  if (e.length > 0) {
    const t = e[0];
    return {
      id: t.id,
      optionId: t.optionId,
      account: t.account,
      sniper: t.sniper,
      bullet: t.bullet,
      initSniper: t.initSniper,
      totalSniper: t.totalSniper,
      totalBullet: t.totalBullet,
      stakedSniper: t.stakedSniper
    };
  } else
    return null;
}
async function C(o) {
  const i = {
    ...r(o)
  };
  return await s(
    (e) => `
  {
    bullets(${e}) {
      id,
      optionId,
      optionType,
      strikePrice,
      exerciseTimestamp
    }
  }
`,
    i
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((e) => e?.bullets ?? []);
}
async function F(o) {
  const i = o ?? {}, e = {
    ...r(i),
    orderBy: "timestamp",
    orderDirection: "desc",
    where: {
      from: "Lock",
      action: "BULLETClaim",
      timestamp_gte: i?.startTime,
      timestamp_lt: i?.endTime
    }
  };
  let t = await s(
    (l) => `
    {
      trades(${l}) {
        id,
        account,
        amount,
        to,
        token,
        txHash,
        timestamp,
        optionType,
        strikePrice,
        exerciseTimestamp
      }
    }
    `,
    e
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((l) => l?.trades ?? []);
  const a = {};
  return t.forEach((l) => {
    const c = a[`${l.token}-${l.txHash}`];
    a[l.token + "-" + l.txHash] = m(c ?? 0).plus(l.amount).toFixed();
  }), t = t.map((l) => ({
    ...l,
    // @ts-expect-error, it is temporarily being ignored
    dailyTotalShareBullet: a[`${l.token}-${l.txHash}`]
  })), o?.address !== void 0 && (t = t.filter(
    (l) => l.account === o.address
  )), t;
}
async function R(o) {
  const i = o ?? {}, e = {
    ...r(i),
    where: {
      seller: i?.address,
      optionType: i.type
    }
  };
  return await s(
    (a) => `
    {
      marketBullets(${a}) {
        id,
        markerBulletId,
        optionType,
        strikePrice,
        exerciseTimestamp,
        seller,
        bullet,
        openTimestamp,
        sellAmount,
        totalSellValue,
        buyToken,
      }
    }
    `,
    e
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((a) => a?.marketBullets ?? []);
}
async function H(o) {
  const i = o ?? {};
  let e = [];
  if (i.address !== void 0) {
    const t = {
      ...r(i),
      id: i.address
    };
    e = await s(
      (a) => `
    {
      user(${a}) {
        id
        lastBulletRewardTimestamp
        tradeCount
      }
    }
    `,
      t
    ).then(
      (a) => (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        a?.user !== void 0 ? [a.user] : []
      )
    );
  } else {
    const t = {
      ...r(i)
    };
    e = await s(
      (a) => `
    {
      users(${a}) {
        id
        lastBulletRewardTimestamp
        tradeCount
      }
    }
    `,
      t
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ).then((a) => a?.users ?? []);
  }
  return e;
}
async function D(o) {
  const i = {
    ...r(o)
  };
  return await s(
    (e) => `
  {
    whitelists(${e}) {
      id,
      isEnable
    }
  }
`,
    i
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((e) => e?.whitelists ?? []);
}
async function O() {
  return await s(
    (i) => `
  {
    distribution(${i}) {
      id
      hodlWithdrawFeeDistribution
      exerciseFeeRatio
      withdrawFeeRatio
      hodlWithdrawFeeRatio
      entryFeeRatio
      bulletToRewardRatio
    }
  }
`,
    {
      id: "Distribution"
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ).then((i) => i?.distribution ?? {});
}
async function _(o = {}) {
  const i = {
    ...r(),
    where: {
      ...o.where
    }
  };
  return await s(
    (e) => `
  {
    dobstakingFlows(${e}) {
      id
      account
      amount
      action
      block
      timestamp
      txHash
    }
  }
  `,
    i
  ).then((e) => e?.dobstakingFlows ?? {});
}
async function E(o = {}) {
  const i = {
    ...r(),
    where: {
      ...o.where
    }
  };
  return await s(
    (e) => `
  {
    offers(${e}) {
      id
      offerId
      seller
      startAt
      endAt
      nftAddress
      nftId
      reservePrice
      highestBid
      highestBidder
      highestBidLastUpdatedAt
      nftClaimed
      rewardClaimed
      txHash
      timestamp
      block
      isClosed
    }
  }
  `,
    i
  ).then((e) => e?.offers ?? {});
}
async function N(o = {}) {
  const i = {
    ...r(),
    where: {
      ...o.where
    }
  };
  return await s(
    (e) => `
  {
    bids(${e}) {
      id
      offerId
      bidder
      bidPrice
      txHash
      timestamp
      block
    }
  }
  `,
    i
  ).then((e) => e?.bids ?? {});
}
async function U(o = {}) {
  const i = {
    ...r(),
    where: {
      ...o.where
    }
  };
  return await s(
    (e) => `
  {
    rewardClaimedFromAuctions(${e}) {
      id
      offerId
      reward
      royalty
      royaltyCollector
      platformFee
      platformFeeCollector
      txHash
      timestamp
      block
    }
  }
  `,
    i
  ).then(
    (e) => e?.rewardClaimedFromAuctions ?? {}
  );
}
export {
  F as getBulletReward,
  C as getBullets,
  _ as getDOBStakingFlows,
  O as getFeeRatio,
  $ as getHODLPoolAccounts,
  T as getHodlPoolList,
  N as getLogBids,
  U as getLogRewardClaimed,
  R as getMarketBulletList,
  E as getOffers,
  P as getOptionAccountById,
  I as getOptionAccountList,
  L as getOptionAccountListByAddress,
  x as getOptionList,
  v as getOptions,
  g as getPools,
  S as getSniperPoolList,
  y as getUserHODLPoolList,
  H as getUserList,
  D as getWhitelist
};
//# sourceMappingURL=subgraph-api.mjs.map
